// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav[data-v-69d59c10]{width:auto;height:100%}.nav .el-col[data-v-69d59c10]{width:100%;height:100%}.nav .el-col .el-menu[data-v-69d59c10]{background-color:transparent;border:none;color:#fff}.nav .el-col .el-avatar[data-v-69d59c10]{margin:20px 0 0 20px}", ""]);
// Exports
module.exports = exports;
